import React from "react";
import { ChevronLeft, Feather } from "lucide-react";
import { Chips, SectionLabel } from "./PlanShared";
import { INTERETS, CONTRAINTES, CONFORTS, EXPERIENCES, DOCUMENTS_OPTIONS } from "./planConstants";

export function Step3Preferences({ data, set, tog, error, onNext, onPrev }) {
  return (
    <div className="animate-fade-in-up mt-8 space-y-6">
      <div>
        <p className="section-label">Étape 3</p>
        <h2 className="text-4xl" style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontWeight: 600, color: "#2B2623" }}>
          Personnalisation
        </h2>
        <p className="text-sm text-[#5C554E] mt-1 italic" style={{ fontFamily: "'Lora', Georgia, serif" }}>
          Plus vous nous dites, plus l'itinéraire sera parfait.
        </p>
      </div>

      <div className="card-surface space-y-1">
        <SectionLabel>Centres d'intérêt</SectionLabel>
        <Chips options={INTERETS} selected={data.centres_interet} onToggle={(v) => tog("centres_interet", v)} />
        <SectionLabel>Contraintes particulières</SectionLabel>
        <Chips options={CONTRAINTES} selected={data.contraintes_medicales} onToggle={(v) => tog("contraintes_medicales", v)} />
        <SectionLabel>Niveau de confort</SectionLabel>
        <Chips options={CONFORTS} selected={[data.confort]} onToggle={(v) => set("confort", v)} />
        <SectionLabel>Expérience voyage</SectionLabel>
        <Chips options={EXPERIENCES} selected={[data.experience_voyage]} onToggle={(v) => set("experience_voyage", v)} />
        <SectionLabel>Documents de voyage</SectionLabel>
        <Chips options={DOCUMENTS_OPTIONS} selected={[data.documents_voyage]} onToggle={(v) => set("documents_voyage", v)} />
        <div className="mt-4">
          <label className="block text-xs uppercase tracking-widest text-[#8B5E34] mb-2" style={{ fontFamily: "'Lora', Georgia, serif" }}>
            Ce que vous voulez absolument faire / éviter
          </label>
          <textarea
            className="input-field-box resize-none"
            rows={3}
            placeholder="Ex: Je veux voir le mont Fuji, mais éviter les foules touristiques..."
            value={data.texte_libre}
            onChange={(e) => set("texte_libre", e.target.value)}
            style={{ fontFamily: "'Lora', Georgia, serif" }}
            data-testid="textarea-texte-libre"
          />
        </div>
      </div>

      {error && (
        <div className="px-4 py-3 bg-red-50 border border-red-200 rounded-sm text-sm text-red-700" style={{ fontFamily: "'Lora', Georgia, serif" }} data-testid="generate-error">
          {error}
        </div>
      )}

      <div className="flex gap-3">
        <button onClick={onPrev} className="btn-secondary flex items-center gap-2" data-testid="step3-prev-btn">
          <ChevronLeft size={15} strokeWidth={2} /> Retour
        </button>
        <button onClick={onNext} className="btn-primary flex-1 flex items-center justify-center gap-2" data-testid="step3-generate-btn">
          <Feather size={15} strokeWidth={1.5} /> Composer mon voyage
        </button>
      </div>
    </div>
  );
}
